import { useEffect, useState } from 'react'
import { UiBreadcrumb } from 'components/common'
import { Box, Flex, Heading, Spinner, Text } from '@chakra-ui/react'
import { getTeamTaskReport } from 'api'
import { TableOnTimeTaskCompletion } from './TableOnTimeTaskCompletion'
import { TableWeeklyTaskCompletion } from './TableWeeklyTaskCompletion'
import { TablePastDueTasks } from './TablePastDueTasks'

const BreadcrumbNav = [
  {
    label: 'Team Task Report',
    isCurrentPage: true
  }
]

export const ProjectTeamTaskReport = () => {
  const [isLoading, setIsLoading] = useState(false)
  const [data, setData] = useState(null)

  const load = async () => {
    setIsLoading(true)
    try {
      const response = await getTeamTaskReport()
      setData(response)
      setIsLoading(false)
    } catch (err) {
      console.log(err)
    }
    setIsLoading(false)
  }

  useEffect(() => {
    load()
  }, [])

  return (
    <>
      <UiBreadcrumb items={BreadcrumbNav} />
      <Box>
        <Flex justifyContent="space-between" alignItems="center" my={8}>
          <Heading size="lg">Team Task Report</Heading>
        </Flex>
        {isLoading ? (
          <Flex alignItems="center" gap={4}>
            <Spinner color="blue.400" size="sm" />
            <Text fontSize="sm">Loading ...</Text>
          </Flex>
        ) : (
          data ? (
            <Flex flexDirection="column" gap={4}>
              <TableOnTimeTaskCompletion data={data} />
              <TableWeeklyTaskCompletion data={data} />
              <TablePastDueTasks data={data} />
            </Flex>
          ) : (
            <Text>No data available.</Text>
          )
        )}
      </Box>
    </>
  )
}
